import { 
    Box,
    Container,
} from '@mui/material';
import Links from './Links';
import Feedback from './Feedback';
import { PROJECT_NAME } from '../../config';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <Container sx={{ height: '100%' }}>
            <Feedback />
            <Box sx={{
                minHeight: {xs: '180px', sm: '150px'}, 
                width: '100%', 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'center',
                gap: 2.5,
                borderTop: '0.3px solid #AAB4BE',
            }}>            
                <Links />
                <Box>
                    {PROJECT_NAME} © {currentYear}
                </Box>
            </Box>
        </Container>
    );
}

export default Footer;